import React from "react"
import { Link } from "gatsby"
import { OutboundLink } from "gatsby-plugin-google-analytics"
import "./Header.scss"

const Header: React.FC = () => (
  <nav className="nav">
    <Link className="logo" to="/">
      IDEAS Lab
    </Link>
    <div className="menu">
      <Link activeClassName="active" to="/">
        主页/Home
      </Link>
      <Link activeClassName="active" to="/members">
        成员/People
      </Link>
      <Link activeClassName="active" to="/publications">
        论文/Publications
      </Link>
      <Link activeClassName="active" to="/events">
        活动/Events
      </Link>
      <Link activeClassName="active" to="/seminars">
        讲座/Seminars
      </Link>
      <OutboundLink target="_blank" href="https://github.com/Ideas-Laboratory">
        代码和数据/Code & Data
      </OutboundLink>
    </div>
  </nav>
)

export default Header
